import PropTypes from "prop-types";
import React from "react";
import styles from "./styles";
import { withRouter } from "react-router-dom";

import { Grid, Paper, withStyles } from "@material-ui/core";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { canvas as canvasStore, filters, pois } from "../../store";

class OfficeResults extends React.Component {
	goToPoi = (event, lot) => {
		event.persist();
		const { history } = this.props;
		history.push(`/lot/${lot}`);

		event.cancelBubble = true;
		if (event.stopPropagation) {
			event.stopPropagation();
		}
		return false;
	};

	render() {
		const handlePoiHover = id => {
			this.props.setPoiId(id);
		};
		const { classes, pois, poiId } = this.props;
		const keys = Object.keys(pois);
		return (
			<div className={classes.root}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						{keys.map(key => {
							const poi = pois[key];
							return (
								<Paper
									key={`poi-${key}`}
									onMouseEnter={() => handlePoiHover(poi.lot)}
									onMouseLeave={() => handlePoiHover(null)}
									onClick={e => {
										this.goToPoi(e, poi.lot);
										this.props.setPoiId();
									}}
									className={`${classes.paper} ${poiId === poi.lot &&
										"active-poi"}`}
								>
									{poi.title}
								</Paper>
							);
						})}
					</Grid>
				</Grid>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	...state.filtered[state.helpers.building],
	...state.canvas[state.helpers.building],
	pois: state.pois[state.helpers.building],
	poiId: state.pois.poi,
	...state.helpers
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			setFloor: filters.setFloor,
			setFrame: canvasStore.setFrame,
			setHoveredLot: canvasStore.setHoveredLot,
			setPoiId: pois.setHoveredPoiId
		},
		dispatch
	);

OfficeResults.propTypes = {
	classes: PropTypes.object.isRequired,
	data: PropTypes.object.isRequired
};

OfficeResults.defaultProps = {
	// settings: null
};

export default withRouter(
	withStyles(styles)(
		connect(mapStateToProps, mapDispatchToProps)(OfficeResults)
	)
);
